module.exports = __webpack_public_path__ + "static/img/web2.a57f2b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/webInstavice/web2.png
// module id = u2HP
// module chunks = 1